module.exports = __webpack_public_path__ + "static/media/img89_R.3ba0c68b.jpg";